import { NotesActions } from '../actions/notes-action-creators.mjs';

const notesReducer = (state, action) => {
  let conversationNotes = state.conversationNotes || {
    isLoading: false,
    notes: []
  };

  switch (action.type) {
    case NotesActions.NOTES_UPDATED: {
      conversationNotes.notes = action.notes;
      conversationNotes.isLoading = false;
      break;
    }

    case NotesActions.NOTE_ADDED: {
      const noteToAdd = action.note;
      conversationNotes.isLoading = false;
      conversationNotes.notes = [
        ...conversationNotes.notes,
        noteToAdd
      ];
      break;
    }

    case NotesActions.NOTE_UPDATED: {
      const noteToUpdate = action.note;
      const notes = conversationNotes.notes;
      conversationNotes.isLoading = false;
      conversationNotes.notes = notes.map(n => n.id === noteToUpdate.id ? noteToUpdate : n);
      break;
    }

    case NotesActions.NOTE_REMOVED: {
      const noteToRemove = action.note;
      const notes = conversationNotes.notes;
      conversationNotes.isLoading = false;
      conversationNotes.notes = notes.filter(n => n.id !== noteToRemove.id);
      break;
    }

    case NotesActions.NOTES_UPDATE_STARTED: {
      conversationNotes.isLoading = true;
      break;
    }

    case NotesActions.NOTE_REQUEST_FAILED: {
      conversationNotes.isLoading = false;
      break;
    }

    default:
      return state;
  }

  return {
    ...state,
    conversationNotes
  };
};

export default notesReducer;
